import script from "./MiniStatisticsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./MiniStatisticsCard.vue?vue&type=script&setup=true&lang=js"

import "./MiniStatisticsCard.vue?vue&type=style&index=0&id=73f590ec&lang=css"

const __exports__ = script;

export default __exports__